import { Injectable } from '@angular/core';
declare let THREE: any;

var getEntity = function(objOrEntity) {
  var result = null;
  if (objOrEntity instanceof THREE.Object3D) result = objOrEntity.userData.entity;
  else if (typeof objOrEntity === 'object') result = objOrEntity;
  return result;
};

@Injectable()
export class ObjectCheckerService {
  constructor() {}

  isWall(obj) {
    return obj.name === 'wall';
  }

  isFloor(obj) {
    return obj.name === 'floor';
  }

  isWallEmbeddable(objOrEntity) {
    var entity = getEntity(objOrEntity);
    return entity && (entity.productType === 'Door' || entity.productType === 'Window');
  }

  isAwning(objOrEntity) {
    const entity = getEntity(objOrEntity);
    return entity && entity.productType === 'Awning';
  }

  isWallMountable(objOrEntity) {
    const entity = getEntity(objOrEntity);
    return entity && (entity.wallInteraction === 'mountable' || this.isAwning(objOrEntity));
  }

  isWindow(objOrEntity) {
    var entity = getEntity(objOrEntity);
    return entity && entity.left_menu_alias === 'Windows';
  }

  isGeneric(objOrEntity) {
    var entity = getEntity(objOrEntity);
    return entity && entity.isGeneric;
  }

  sameWallInteraction(objOrEntity1, objOrEntity2) {
    var entity1 = getEntity(objOrEntity1);
    var entity2 = getEntity(objOrEntity2);
    return entity1 && entity2 && entity1.wallInteraction === entity2.wallInteraction;
  }

  isWallOrFloor(objOrEntity) {
    return this.isFloor(objOrEntity) || this.isWall(objOrEntity);
  }

  iteractWithWall(objOrEntity) {
    return this.isWallMountable(objOrEntity) || this.isWallEmbeddable(objOrEntity);
  }

  isObject(objOrEntity) {
    return getEntity(objOrEntity);
  }

  isDoor(objOrEntity) {
    var entity = getEntity(objOrEntity);
    return entity && entity.left_menu_alias.toLowerCase().indexOf('door') !== -1;
  }

  isSelectable(obj) {
    return (
      obj.userData.isDeckComponent ||
      obj.name === 'Accessory' ||
      this.isWallEmbeddable(obj) ||
      this.isWallMountable(obj)
    );
  }

  isAccessory(obj) {
    return obj.name === 'Accessory';
  }

  isStairs(obj) {
    return obj.name === 'stairs';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/object-checker.service.ts